import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import logoIcon from "@/assets/logo-warmzapp.webp";

const PrivacyPolicy = () => (
  <div className="min-h-screen bg-background text-foreground">
    <header className="border-b border-border py-4">
      <div className="container mx-auto px-4 md:px-8 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-1 font-display text-xl font-bold">
          <img src={logoIcon} alt="WarmZapp" className="h-9 w-auto" />
          Warm<span className="text-primary">Zapp</span>
        </Link>
        <Link to="/" className="flex items-center gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors">
          <ArrowLeft className="h-4 w-4" /> Voltar
        </Link>
      </div>
    </header>

    <main className="container mx-auto px-4 md:px-8 py-12 max-w-3xl space-y-8">
      <h1 className="font-display text-3xl md:text-4xl font-bold">Política de Privacidade</h1>
      <p className="text-muted-foreground">Última atualização: 2 de março de 2026</p>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">1. Informações que Coletamos</h2>
        <p className="text-muted-foreground leading-relaxed">
          Coletamos informações que você nos fornece diretamente, como nome, endereço de e-mail e número de telefone ao criar uma conta. Também coletamos dados de uso automaticamente, incluindo endereço IP, tipo de navegador e páginas visitadas.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">2. Como Usamos suas Informações</h2>
        <p className="text-muted-foreground leading-relaxed">
          Utilizamos suas informações para fornecer, manter e melhorar nossos serviços, processar transações, enviar comunicações relacionadas ao serviço e personalizar sua experiência na plataforma.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">3. Compartilhamento de Dados</h2>
        <p className="text-muted-foreground leading-relaxed">
          Não vendemos suas informações pessoais. Podemos compartilhar dados com prestadores de serviços terceirizados que nos auxiliam na operação da plataforma, sempre sob acordos de confidencialidade.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">4. Segurança dos Dados</h2>
        <p className="text-muted-foreground leading-relaxed">
          Implementamos medidas de segurança técnicas e organizacionais para proteger suas informações contra acesso não autorizado, alteração, divulgação ou destruição.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">5. Seus Direitos</h2>
        <p className="text-muted-foreground leading-relaxed">
          Você tem o direito de acessar, corrigir ou excluir suas informações pessoais a qualquer momento. Para exercer esses direitos, entre em contato conosco através das configurações da sua conta ou pelo e-mail suporte@warmzapp.com.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">6. Cookies</h2>
        <p className="text-muted-foreground leading-relaxed">
          Utilizamos cookies e tecnologias similares para melhorar a experiência do usuário, analisar o tráfego do site e personalizar conteúdo. Você pode gerenciar suas preferências de cookies nas configurações do seu navegador.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="font-display text-xl font-semibold">7. Contato</h2>
        <p className="text-muted-foreground leading-relaxed">
          Se você tiver dúvidas sobre esta Política de Privacidade, entre em contato conosco pelo e-mail suporte@warmzapp.com.
        </p>
      </section>
    </main>
  </div>
);

export default PrivacyPolicy;
